import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { TrackerService } from '../../services/tracker.service';
import { GfTranslateService } from '../../../../core/services/core.translate.service';
import * as _ from 'lodash';

@Component({
  selector: 'ti-field-list',
  template: require('./trackeritem.field-list.component.html')
})
export class FieldListComponent implements OnInit {
  errors: any;
  @Input() tracker: any;
  @Input() trackeritem: any;
  @Input() acls: any;
  @Input() sprint: any;
  @Input() allowEdit: boolean;
  
  hasEnabledFields: boolean;

  constructor(private trackerService: TrackerService, private translateService: GfTranslateService) {}

  ngOnInit(): void {
    this.init();
  }

  ngOnChanges(): void {
    this.init();
  }

  private anyFieldsEnabled(): boolean {
    const enabled = _.values(_.get(this.tracker, 'fields', {}))
      .filter((f: any) => f.isExtraField && f.isEnabled && f.fieldType !== 7);

    if (enabled.length) return true;

    return _.get(this.tracker, 'fields.sprint.isEnabled', false);
  }

  private init() {
    this.hasEnabledFields = this.anyFieldsEnabled();

    // If there's no sprint selected, set the "none" option
    if (_.isEmpty(this.trackeritem?.sprint?.fieldData)) {
      this.trackeritem.sprint.fieldData = { id: 100, label: this.translateService.translate("None") };
    }

    if (_.get(this.tracker, 'fields.sprint.isEnabled', false)) {
      this.tracker.fields.sprint.fieldElements = this.trackerService.fields.getSprintsGroupedByStatus(this.tracker.fields.sprint);
    }

    for (const i in this.tracker.fields) {
      if (this.tracker.fields[i].fieldType === 8) {
        this.tracker.fields[i].fieldElements = this.trackerService.fields.getReleasesGroupedByStatus(this.tracker.fields[i]);
      }
    }
  }
}
